import { useUserTenantPreference } from 'kineticUtils/hooks';
import { AppSearchHistoryPreference, AppSearchItem, AppSearchItemType } from './types';
import { useCallback } from 'react';
import { PREFERENCE_KEYS } from 'types';

export const useAppSearchHistory = () => {
  const {
    value: { searchTerms: searchHistory = [] },
    setPreference,
  } = useUserTenantPreference<AppSearchHistoryPreference>({
    key: PREFERENCE_KEYS.APP_SEARCH_HISTORY,
  });

  const deleteSearchHistory = useCallback(
    (searchTermToDelete: AppSearchItem) => {
      if (searchHistory.length === 0) {
        return;
      }
      const toSave: AppSearchItem[] = [...searchHistory];
      const existingTermIndex = toSave.findIndex(
        (searchTerm) =>
          searchTerm.name === searchTermToDelete.name && searchTerm.link === searchTermToDelete.link
      );
      if (existingTermIndex >= 0) {
        toSave.splice(existingTermIndex, 1);
      }

      setPreference({ searchTerms: toSave });
    },
    [setPreference, searchHistory]
  );

  const addSearchHistory = useCallback(
    (newSearchTerm: AppSearchItem) => {
      const maxCount = newSearchTerm.type === AppSearchItemType.View ? 25 : 5;

      if (searchHistory.length === 0) {
        setPreference({ searchTerms: [newSearchTerm] });
        return;
      }
      const toSave: AppSearchItem[] = [...searchHistory];
      const existingTermIndex = toSave.findIndex(
        (searchTerm) =>
          searchTerm.name === newSearchTerm.name && searchTerm.link === newSearchTerm.link
      );
      if (existingTermIndex >= 0) {
        toSave.splice(existingTermIndex, 1);
      }
      if (toSave.length >= maxCount) {
        toSave.pop();
      }
      toSave.unshift(newSearchTerm);
      setPreference({ searchTerms: toSave });
    },
    [setPreference, searchHistory]
  );

  return {
    addSearchHistory,
    deleteSearchHistory,
    searchHistory,
  };
};
